import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ActivatedRouteSnapshot, Router } from "@angular/router";
import { TransferState, makeStateKey } from "@angular/platform-browser";
import { of } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class ActionTrackerService {
  constructor(
    private readonly http: HttpClient,
    private readonly router: Router,
    private readonly transferState: TransferState
  ) {}
  actionTrackerRoute = "action-tracker";
  resolve(route: ActivatedRouteSnapshot): any {
    let id = route.params["id"];
    try {
      id = atob(id);
    } catch (e) {
      this.router.navigate(["404"]);
    }
    return this.http.get(`${this.actionTrackerRoute}/` + id);
  }

  getVendorList() {
    return this.http.get(
      "dynamic-form/?form_name=opportunity_empanelled_vendors"
    );
  }

  getAssigneeList() {
    const detailKey = makeStateKey(`dynamic-form/?form_name=opportunity_teams`);
    const cachedResponse = this.transferState.get(detailKey, null);
    if (!cachedResponse) {
      return this.http
        .get("dynamic-form/?form_name=opportunity_teams")
        .pipe(tap((res: any) => this.transferState.set(detailKey, res)));
    }
    return of(cachedResponse);
  }

  getActionTrackerDetails(id: any) {
    return this.http.get(`${this.actionTrackerRoute}/${id}/`);
  }

  updateComments(data: any, id: any) {
    return this.http.post(
      `action-tracker/add-update-comments-to-action-tracker/${id}/`,
      data
    );
  }
  updateassignee(data: any, id: any) {
    return this.http.patch(`action-tracker/update-action-tracker/${id}/`, data);
  }

  getStatusFieldValues() {
    const detailKey = makeStateKey(`action-tracker-status-list`);
    const cachedResponse = this.transferState.get(detailKey, null);
    if (!cachedResponse) {
      return this.http
        .get("action-tracker/action-tracker-status-list/")
        .pipe(tap((res: any) => this.transferState.set(detailKey, res)));
    }
    return of(cachedResponse);
  }

  downloadFile(payload: any, trackerId: any) {
    return this.http.post(
      `action-tracker/action-tracker-file-download/${trackerId}/`,
      payload,
      { responseType: "blob" }
    );
  }

  deleteCommands(id: any) {
    return this.http.delete(
      `action-tracker/delete-action-tracker-comment/${id}/`
    );
  }

  updateStatus(data: any) {
    return this.http.post("action-tracker/update-action-tracker-status/", data);
  }

  submitForm(payload: any) {
    return this.http.post("action-tracker/add-action-tracker/", payload, {
      responseType: "blob",
    });
  }

  //=========================================================================
  getActionCategory() {
    return this.http.get(`${this.actionTrackerRoute}/category/`);
  }
  getUser() {
    return this.http.get(`users/user-list/`);
  }
  getOpportunity() {
    return this.http.get(`opportunities/names/`);
  }

  getProject() {
    return this.http.get(`projects/`);
  }

  getPulses() {
    return this.http.get("nps/pulses/get-pulses");
  }
  getParadeList() {
    return this.http.get(`parade/parade/`);
  }
  getCuratedInsightList() {
    return this.http.get(`insights/insights/`);
  }
  getRiskMitigationList() {
    return this.http.get(`risk/risk-mitigations/`);
  }
  getActionTrackerListNew(qParam: string) {
    return this.http.get(`${this.actionTrackerRoute}/?${qParam}`);
  }
  deleteActionTrackerById(trackerId: any) {
    return this.http.delete(`${this.actionTrackerRoute}/${trackerId}/`);
  }
  updateActionTracerById(data: any, id: any) {
    return this.http.patch(`${this.actionTrackerRoute}/${id}/`, data);
  }
  addNewActionTracker(data: any) {
    return this.http.post(`${this.actionTrackerRoute}/`, data);
  }
  deleteFile(fileId: number) {
    return this.http.delete(
      `${this.actionTrackerRoute}/delete-file?file_id=${fileId}`
    );
  }

  downloadActionTrackerFile(fileId: number) {
    return this.http.get(
      `${this.actionTrackerRoute}/download-file?file_id=${fileId}`,
      {
        responseType: "blob",
      }
    );
  }

  getActionHistory(id: any, historyType?: 'action' | 'compliance') {
    const params = historyType ? `?history_type=${historyType}` : '';
    return this.http.get(`${this.actionTrackerRoute}/${id}/history/${params}`);
  }

  downloadHistoryFile(actionId: number, fileId: number) {
    return this.http.get(
      `${this.actionTrackerRoute}/${actionId}/history-file-download/?file_id=${fileId}`,
      {
        responseType: "blob",
      }
    );
  }
}
